export const adminTranslations = {
  en: {
    // Layout / Sidebar
    'sidebar.title': 'VIYERO Admin',
    'sidebar.welcome': 'Welcome',
    'sidebar.dashboard': 'Dashboard',
    'sidebar.homepage': 'Homepage',
    'sidebar.gaming': 'Gaming Page',
    'sidebar.office': 'Home & Office',
    'sidebar.products': 'Products',
    'sidebar.about': 'About',
    'sidebar.contact': 'Contact',
    'sidebar.settings': 'Settings',
    'sidebar.support': 'Support',
    'sidebar.headerFooter': 'Header & Footer',
    'sidebar.logout': 'Logout',

    // Common
    'common.save': 'Save Changes',
    'common.saving': 'Saving...',
    'common.saveAll': 'Save All Changes',
    'common.savingAll': 'Saving Changes...',
    'common.back': 'Back',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.cancel': 'Cancel',
    'common.search': 'Search',
    'common.all': 'All',
    'common.gaming': 'Gaming',
    'common.office': 'Office',
    'common.english': 'English',
    'common.turkish': 'Turkce',
    'common.loading': 'Loading...',
    'common.title': 'Title',
    'common.description': 'Description',
    'common.buttonText': 'Button Text',

    // Login
    'login.title': 'VIYERO Admin',
    'login.subtitle': 'Sign in to manage your website',
    'login.username': 'Username',
    'login.password': 'Password',
    'login.usernamePlaceholder': 'Enter username',
    'login.passwordPlaceholder': 'Enter password',
    'login.submit': 'Sign In',
    'login.submitting': 'Signing in...',
    'login.success': 'Login successful!',
    'login.error': 'Login failed. Please check your credentials.',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.subtitle': 'Manage your VIYERO website content',
    'dashboard.homepageContent': 'Homepage Content',
    'dashboard.homepageDesc': 'Edit hero section, categories, and values',
    'dashboard.products': 'Products',
    'dashboard.productsDesc': 'Manage your product catalog',
    'dashboard.aboutPage': 'About Page',
    'dashboard.aboutDesc': 'Update company information and mission',
    'dashboard.contactInfo': 'Contact Info',
    'dashboard.contactDesc': 'Manage email and address details',
    'dashboard.supportPage': 'Support Page',
    'dashboard.supportDesc': 'Manage support page categories and manuals',
    'dashboard.headerFooter': 'Header & Footer',
    'dashboard.headerFooterDesc': 'Edit logos, navigation labels, and footer content',
    'dashboard.quickTips': 'Quick Tips',
    'dashboard.tip1': 'All changes are saved immediately and reflected on your website',
    'dashboard.tip2': 'Make sure to preview your changes before closing the admin panel',
    'dashboard.tip3': 'Product images should be high-quality for best results',
    'dashboard.tip4': 'Keep descriptions concise and engaging',

    // Products
    'products.title': 'Products',
    'products.count': 'products in database',
    'products.searchPlaceholder': 'Search by name or model...',
    'products.addNew': 'Add New Product',
    'products.importStatic': 'Import from Static Data',
    'products.importing': 'Importing...',
    'products.noProducts': 'No products in database',
    'products.noProductsDesc': 'Click "Import from Static Data" to load your existing products into the database for editing.',
    'products.deleted': 'Product deleted',
    'products.deleteFailed': 'Failed to delete product',
    'products.deleteConfirm': 'Are you sure you want to delete this product?',
    'products.importConfirm': 'This will import all static product data into the database. Continue?',
    'products.noCategoryResults': 'No products in this category yet.',

    // Product Edit
    'productEdit.newProduct': 'New Product',
    'productEdit.createNew': 'Create a new product',
    'productEdit.createProduct': 'Create Product',
    'productEdit.identity': 'Product Identity',
    'productEdit.productId': 'Product ID (unique, no spaces)',
    'productEdit.modelNumber': 'Model Number',
    'productEdit.category': 'Category',
    'productEdit.selectCategory': 'Select category...',
    'productEdit.addNewCategory': '+ Add New Category...',
    'productEdit.typeCategoryName': 'Type new category name...',
    'productEdit.type': 'Type',
    'productEdit.productText': 'Product Text',
    'productEdit.displayName': 'Display Name',
    'productEdit.displayNameHint': 'Press Enter for line break on product page',
    'productEdit.shortDesc': 'Short Description',
    'productEdit.shortDescPlaceholder': 'Brief tagline...',
    'productEdit.fullDesc': 'Full Description',
    'productEdit.fullDescPlaceholder': 'Detailed product description...',
    'productEdit.textColors': 'Text Colors',
    'productEdit.titleColor': 'Title Color',
    'productEdit.descColor': 'Description Color',
    'productEdit.featureColor': 'Feature Color',
    'productEdit.specColor': 'Spec Color',
    'productEdit.features': 'Features',
    'productEdit.addFeature': 'Add Feature',
    'productEdit.noFeatures': 'No features yet. Click "Add Feature" to start.',
    'productEdit.specifications': 'Specifications',
    'productEdit.addSpec': 'Add Spec',
    'productEdit.enterSpecName': 'Enter spec name',
    'productEdit.images': 'Images',
    'productEdit.cardImage': 'Card Image',
    'productEdit.cardImageTr': 'Card Image (Turkish)',
    'productEdit.galleryEn': 'Gallery Images (English)',
    'productEdit.galleryTr': 'Gallery Images (Turkish)',
    'productEdit.addImage': 'Add Image URL',
    'productEdit.addTrImage': 'Add Turkish Image URL',
    'productEdit.uploadImage': 'Upload Image',
    'productEdit.uploadTrImage': 'Upload TR Image',
    'productEdit.updated': 'Product updated successfully!',
    'productEdit.created': 'Product created successfully!',
    'productEdit.saveFailed': 'Failed to save',
    'productEdit.loadFailed': 'Failed to load product',
    'productEdit.idRequired': 'Product ID is required',

    // Homepage Editor
    'homepage.title': 'Homepage Content',
    'homepage.subtitle': 'Manage your homepage text and messaging',
    'homepage.heroSection': 'Hero Section',
    'homepage.heroDesc': 'Main headline and description',
    'homepage.heroTitle': 'Hero Title',
    'homepage.heroDescription': 'Hero Description',
    'homepage.gamingSection': 'Gaming Hardware Section',
    'homepage.gamingSectionDesc': 'Content for gaming category card',
    'homepage.officeSection': 'Office & Home Section',
    'homepage.officeSectionDesc': 'Content for office category card',
    'homepage.whyChoose': 'Why Choose VIYERO',
    'homepage.whyChooseDesc': 'Value proposition section',
    'homepage.sectionTitle': 'Section Title',
    'homepage.sectionDescription': 'Section Description',
    'homepage.value': 'Value',
    'homepage.cta': 'Call to Action',
    'homepage.ctaDesc': 'Bottom CTA section',
    'homepage.ctaTitle': 'CTA Title',
    'homepage.ctaDescription': 'CTA Description',
    'homepage.cardImage': 'Card Image',
    'homepage.categoryLabel': 'Category Label (overlay text above title)',
    'homepage.labelIcon': 'Label Icon (small image before label text)',
    'homepage.labelIconPlaceholder': 'Icon image URL (leave empty for default)',
    'homepage.cardLogo': 'Card Watermark Logo (bottom-right)',
    'homepage.cardLogoPlaceholder': 'Logo URL (leave empty to hide)',

    // About Editor
    'about.title': 'About Page',
    'about.subtitle': 'Edit your company information',
    'about.content': 'About Content',
    'about.pageTitle': 'Page Title',
    'about.tagline': 'Tagline',
    'about.mission': 'Mission Statement',

    // Contact Editor
    'contact.title': 'Contact Information',
    'contact.subtitle': 'Manage your contact details',
    'contact.details': 'Contact Details',
    'contact.email': 'Email Address',
    'contact.address': 'Business Address',
    'contact.image': 'Page Image',
    'contact.ogImage': 'Social Share Image (OG Image)',
    'contact.ogImageDesc': 'Square image shown when sharing website link on WhatsApp, Facebook, Twitter etc.',
    'contact.ogTitle': 'Social Share Title',
    'contact.ogDescription': 'Social Share Description',
    'contact.messages': 'Contact Messages',
    'contact.totalMessages': 'total messages',
    'contact.noMessages': 'No messages yet',
    'contact.refresh': 'Refresh',
    'contact.deleteConfirm': 'Delete this message?',
    'contact.deleted': 'Message deleted',
    'contact.markRead': 'Read',

    // Settings
    'settings.title': 'Settings',
    'settings.changePassword': 'Change Password',
    'settings.currentPassword': 'Current Password',
    'settings.newPassword': 'New Password',
    'settings.confirmPassword': 'Confirm New Password',
    'settings.changingPassword': 'Changing Password...',
    'settings.passwordMismatch': 'New passwords do not match',
    'settings.passwordTooShort': 'Password must be at least 6 characters',
    'settings.passwordChanged': 'Password changed successfully!',

    // Category names (must match public site translations)
    'cat.Accessories': 'Accessories',
    'cat.Dyson Stands': 'Dyson Stands',
    'cat.Gaming Accessories': 'Gaming Accessories',
    'cat.Gaming Desks': 'Gaming Desks',
    'cat.Gaming Monitor Arms': 'Gaming Monitor Arms',
    'cat.Mobile TV Stands': 'Mobile TV Stands',
    'cat.Monitor Arms': 'Monitor Arms',
    'cat.TV Stands': 'TV Stands',

    // Admin Gaming Page
    'adminGaming.title': 'Gaming Page',
    'adminGaming.subtitle': 'Edit gaming page hero and category cards',
    'adminGaming.heroDesc': 'Gaming page main headline',
    'adminGaming.heroHighlight': 'Highlighted Text',
    'adminGaming.categories': 'Category Cards',
    'adminGaming.categoriesDesc': 'Category cards shown on the gaming page',
    'adminGaming.addCategory': 'Add Category',
    'adminGaming.category': 'Category',
    'adminGaming.categoryKey': 'Category Key (must match product category)',
    'adminGaming.categoryLabel': 'Display Label',
    'adminGaming.categoryImage': 'Card Image URL',

    // Admin Office Page
    'adminOffice.title': 'Home & Office Page',
    'adminOffice.subtitle': 'Edit home & office page hero and category cards',
    'adminOffice.heroDesc': 'Office page main headline',
    'adminOffice.heroHighlight': 'Highlighted Text',
    'adminOffice.categories': 'Category Cards',
    'adminOffice.categoriesDesc': 'Category cards shown on the office page',

    // Admin Support Page
    'adminSupport.title': 'Support Page',
    'adminSupport.subtitle': 'Edit support page hero and category sections',
    'adminSupport.heroDesc': 'Support page main headline',
    'adminSupport.categories': 'Support Categories',
    'adminSupport.categoriesDesc': 'Product categories shown on the support page with manuals',
    'adminSupport.addCategory': 'Add Category',
    'adminSupport.category': 'Category',
    'adminSupport.categoryKey': 'Category Key (must match product category)',
    'adminSupport.categoryLabel': 'Display Label',
    'adminSupport.categoryProductType': 'Product Type (gaming/office)',

    // Admin Header & Footer
    'adminHF.title': 'Header & Footer',
    'adminHF.subtitle': 'Edit logos, navigation labels, language flags, and footer content',
    'adminHF.logos': 'Site Logos',
    'adminHF.logosDesc': 'Manage VIYERO logos used across the site',
    'adminHF.headerLogo': 'Header Logo (Main)',
    'adminHF.footerLogo': 'Footer Logo (White)',
    'adminHF.gamingLogo': 'Gaming Sub-brand Logo',
    'adminHF.navLabels': 'Navigation Menu Labels',
    'adminHF.navLabelsDesc': 'Edit the text shown in the top navigation menu',
    'adminHF.langFlags': 'Language Flags',
    'adminHF.langFlagsDesc': 'Custom flag images for the language switcher',
    'adminHF.enFlag': 'English Flag Image',
    'adminHF.trFlag': 'Turkish Flag Image',
    'adminHF.footerContent': 'Footer Content',
    'adminHF.footerContentDesc': 'Edit footer text, section titles, and contact info',
    'adminHF.footerDescription': 'Footer Description',
    'adminHF.productsTitle': 'Products Section Title',
    'adminHF.companyTitle': 'Company Section Title',
    'adminHF.gamingLink': 'Gaming Link Text',
    'adminHF.officeLink': 'Office Link Text',
    'adminHF.aboutLink': 'About Link Text',
    'adminHF.contactLink': 'Contact Link Text',
    'adminHF.email': 'Contact Email',
    'adminHF.address': 'Address',
  },

  tr: {
    // Layout / Sidebar
    'sidebar.title': 'VIYERO Yönetim',
    'sidebar.welcome': 'Hoşgeldiniz',
    'sidebar.dashboard': 'Kontrol Paneli',
    'sidebar.homepage': 'Ana Sayfa',
    'sidebar.gaming': 'Gaming Sayfası',
    'sidebar.office': 'Ev & Ofis',
    'sidebar.products': 'Ürünler',
    'sidebar.about': 'Hakkımızda',
    'sidebar.contact': 'İletişim',
    'sidebar.settings': 'Ayarlar',
    'sidebar.support': 'Destek',
    'sidebar.headerFooter': 'Ust & Alt Bilgi',
    'sidebar.logout': 'Cikis Yap',

    // Common
    'common.save': 'Değişiklikleri Kaydet',
    'common.saving': 'Kaydediliyor...',
    'common.saveAll': 'Tümünü Kaydet',
    'common.savingAll': 'Değişiklikler Kaydediliyor...',
    'common.back': 'Geri',
    'common.edit': 'Düzenle',
    'common.delete': 'Sil',
    'common.cancel': 'İptal',
    'common.search': 'Ara',
    'common.all': 'Tümü',
    'common.gaming': 'Gaming',
    'common.office': 'Ofis',
    'common.english': 'İngilizce',
    'common.turkish': 'Türkçe',
    'common.loading': 'Yükleniyor...',
    'common.title': 'Başlık',
    'common.description': 'Açıklama',
    'common.buttonText': 'Buton Metni',

    // Login
    'login.title': 'VIYERO Yönetim',
    'login.subtitle': 'Web sitenizi yönetmek için giriş yapın',
    'login.username': 'Kullanıcı Adı',
    'login.password': 'Şifre',
    'login.usernamePlaceholder': 'Kullanıcı adınızı girin',
    'login.passwordPlaceholder': 'Şifrenizi girin',
    'login.submit': 'Giriş Yap',
    'login.submitting': 'Giriş yapılıyor...',
    'login.success': 'Giriş başarılı!',
    'login.error': 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.',

    // Dashboard
    'dashboard.title': 'Kontrol Paneli',
    'dashboard.subtitle': 'VIYERO web sitesi içeriklerinizi yönetin',
    'dashboard.homepageContent': 'Ana Sayfa İçeriği',
    'dashboard.homepageDesc': 'Hero bölümü, kategoriler ve değerleri düzenleyin',
    'dashboard.products': 'Ürünler',
    'dashboard.productsDesc': 'Ürün kataloğunuzu yönetin',
    'dashboard.aboutPage': 'Hakkımızda Sayfası',
    'dashboard.aboutDesc': 'Şirket bilgilerini ve misyonu güncelleyin',
    'dashboard.contactInfo': 'İletişim Bilgileri',
    'dashboard.contactDesc': 'E-posta ve adres bilgilerini yönetin',
    'dashboard.supportPage': 'Destek Sayfası',
    'dashboard.supportDesc': 'Destek sayfası kategorilerini ve kılavuzları yönetin',
    'dashboard.headerFooter': 'Ust & Alt Bilgi',
    'dashboard.headerFooterDesc': 'Logo, navigasyon etiketleri ve alt bilgi icerigini duzenleyin',
    'dashboard.quickTips': 'Hızlı İpuçları',
    'dashboard.tip1': 'Tüm değişiklikler anında kaydedilir ve web sitenize yansır',
    'dashboard.tip2': 'Yönetim panelini kapatmadan önce değişikliklerinizi önizleyin',
    'dashboard.tip3': 'En iyi sonuçlar için yüksek kaliteli ürün görselleri kullanın',
    'dashboard.tip4': 'Açıklamaları kısa ve ilgi çekici tutun',

    // Products
    'products.title': 'Ürünler',
    'products.count': 'ürün veritabanında',
    'products.searchPlaceholder': 'İsim veya model ile ara...',
    'products.addNew': 'Yeni Ürün Ekle',
    'products.importStatic': 'Statik Veriden İçe Aktar',
    'products.importing': 'İçe aktarılıyor...',
    'products.noProducts': 'Veritabanında ürün yok',
    'products.noProductsDesc': 'Mevcut ürünlerinizi düzenlemek için veritabanına yüklemek üzere "Statik Veriden İçe Aktar" seçeneğini kullanın.',
    'products.deleted': 'Ürün silindi',
    'products.deleteFailed': 'Ürün silinemedi',
    'products.deleteConfirm': 'Bu ürünü silmek istediğinizden emin misiniz?',
    'products.importConfirm': 'Tüm statik ürün verileri veritabanına aktarılacak. Devam edilsin mi?',
    'products.noCategoryResults': 'Bu kategoride henüz ürün yok.',

    // Product Edit
    'productEdit.newProduct': 'Yeni Ürün',
    'productEdit.createNew': 'Yeni bir ürün oluşturun',
    'productEdit.createProduct': 'Ürün Oluştur',
    'productEdit.identity': 'Ürün Kimliği',
    'productEdit.productId': 'Ürün ID (benzersiz, boşluksuz)',
    'productEdit.modelNumber': 'Model Numarası',
    'productEdit.category': 'Kategori',
    'productEdit.selectCategory': 'Kategori seçin...',
    'productEdit.addNewCategory': '+ Yeni Kategori Ekle...',
    'productEdit.typeCategoryName': 'Yeni kategori adını yazın...',
    'productEdit.type': 'Tür',
    'productEdit.productText': 'Ürün Metni',
    'productEdit.displayName': 'Görüntülenecek Ad',
    'productEdit.displayNameHint': 'Ürün sayfasında satır sonu için Enter tuşuna basın',
    'productEdit.shortDesc': 'Kısa Açıklama',
    'productEdit.shortDescPlaceholder': 'Kısa tanıtım...',
    'productEdit.fullDesc': 'Detaylı Açıklama',
    'productEdit.fullDescPlaceholder': 'Ayrıntılı ürün açıklaması...',
    'productEdit.textColors': 'Metin Renkleri',
    'productEdit.titleColor': 'Başlık Rengi',
    'productEdit.descColor': 'Açıklama Rengi',
    'productEdit.featureColor': 'Özellik Rengi',
    'productEdit.specColor': 'Teknik Bilgi Rengi',
    'productEdit.features': 'Özellikler',
    'productEdit.addFeature': 'Özellik Ekle',
    'productEdit.noFeatures': 'Henüz özellik eklenmedi. Başlamak için "Özellik Ekle" seçeneğini kullanın.',
    'productEdit.specifications': 'Teknik Özellikler',
    'productEdit.addSpec': 'Teknik Bilgi Ekle',
    'productEdit.enterSpecName': 'Teknik bilgi adını girin',
    'productEdit.images': 'Görseller',
    'productEdit.cardImage': 'Kart Görseli',
    'productEdit.cardImageTr': 'Kart Görseli (Türkçe)',
    'productEdit.galleryEn': 'Galeri Görselleri (İngilizce)',
    'productEdit.galleryTr': 'Galeri Görselleri (Türkçe)',
    'productEdit.addImage': 'URL Ekle',
    'productEdit.addTrImage': 'Türkçe URL Ekle',
    'productEdit.uploadImage': 'Görsel Yükle',
    'productEdit.uploadTrImage': 'TR Görsel Yükle',
    'productEdit.updated': 'Ürün başarıyla güncellendi!',
    'productEdit.created': 'Ürün başarıyla oluşturuldu!',
    'productEdit.saveFailed': 'Kaydetme başarısız',
    'productEdit.loadFailed': 'Ürün yüklenemedi',
    'productEdit.idRequired': 'Ürün ID gereklidir',

    // Homepage Editor
    'homepage.title': 'Ana Sayfa İçeriği',
    'homepage.subtitle': 'Ana sayfa metin ve mesajlarını yönetin',
    'homepage.heroSection': 'Hero Bölümü',
    'homepage.heroDesc': 'Ana başlık ve açıklama',
    'homepage.heroTitle': 'Hero Başlığı',
    'homepage.heroDescription': 'Hero Açıklaması',
    'homepage.gamingSection': 'Gaming Donanım Bölümü',
    'homepage.gamingSectionDesc': 'Gaming kategorisi kartı için içerik',
    'homepage.officeSection': 'Ofis & Ev Bölümü',
    'homepage.officeSectionDesc': 'Ofis kategorisi kartı için içerik',
    'homepage.whyChoose': 'Neden VIYERO?',
    'homepage.whyChooseDesc': 'Değer önerisi bölümü',
    'homepage.sectionTitle': 'Bölüm Başlığı',
    'homepage.sectionDescription': 'Bölüm Açıklaması',
    'homepage.value': 'Değer',
    'homepage.cta': 'Harekete Geçirici Mesaj',
    'homepage.ctaDesc': 'Alt kısım CTA bölümü',
    'homepage.ctaTitle': 'CTA Basligi',
    'homepage.ctaDescription': 'CTA Aciklamasi',
    'homepage.cardImage': 'Kart Gorseli',
    'homepage.categoryLabel': 'Kategori Etiketi (baslik uzerindeki metin)',
    'homepage.labelIcon': 'Etiket Ikonu (etiket metninden onceki kucuk gorsel)',
    'homepage.labelIconPlaceholder': 'Ikon gorsel URL (varsayilan icin bos birakin)',
    'homepage.cardLogo': 'Kart Filigran Logosu (sag alt)',
    'homepage.cardLogoPlaceholder': 'Logo URL (gizlemek icin bos birakin)',

    // About Editor
    'about.title': 'Hakkımızda Sayfası',
    'about.subtitle': 'Şirket bilgilerinizi düzenleyin',
    'about.content': 'Hakkımızda İçeriği',
    'about.pageTitle': 'Sayfa Başlığı',
    'about.tagline': 'Slogan',
    'about.mission': 'Misyon Bildirisi',

    // Contact Editor
    'contact.title': 'İletişim Bilgileri',
    'contact.subtitle': 'İletişim detaylarınızı yönetin',
    'contact.details': 'İletişim Detayları',
    'contact.email': 'E-posta Adresi',
    'contact.address': 'Is Adresi',
    'contact.image': 'Sayfa Gorseli',
    'contact.ogImage': 'Sosyal Paylasim Gorseli (OG Gorseli)',
    'contact.ogImageDesc': 'WhatsApp, Facebook, Twitter vb. uzerinde web sitesi linkini paylasirken gosterilen kare gorsel.',
    'contact.ogTitle': 'Sosyal Paylasim Basligi',
    'contact.ogDescription': 'Sosyal Paylasim Aciklamasi',
    'contact.messages': 'Iletisim Mesajlari',
    'contact.totalMessages': 'toplam mesaj',
    'contact.noMessages': 'Henuz mesaj yok',
    'contact.refresh': 'Yenile',
    'contact.deleteConfirm': 'Bu mesaji silinsin mi?',
    'contact.deleted': 'Mesaj silindi',
    'contact.markRead': 'Okundu',

    // Settings
    'settings.title': 'Ayarlar',
    'settings.changePassword': 'Şifre Değiştir',
    'settings.currentPassword': 'Mevcut Şifre',
    'settings.newPassword': 'Yeni Şifre',
    'settings.confirmPassword': 'Yeni Şifre (Tekrar)',
    'settings.changingPassword': 'Şifre değiştiriliyor...',
    'settings.passwordMismatch': 'Yeni şifreler eşleşmiyor',
    'settings.passwordTooShort': 'Şifre en az 6 karakter olmalıdır',
    'settings.passwordChanged': 'Şifre başarıyla değiştirildi!',

    // Category names (must match public site translations)
    'cat.Accessories': 'Aksesuarlar',
    'cat.Dyson Stands': 'Dyson Standları',
    'cat.Gaming Accessories': 'Aksesuarlar',
    'cat.Gaming Desks': 'Oyuncu Masaları',
    'cat.Gaming Monitor Arms': 'Monitör Kolları',
    'cat.Mobile TV Stands': 'Mobil TV Standları',
    'cat.Monitor Arms': 'Monitör Kolları',
    'cat.TV Stands': 'TV Standları',

    // Admin Gaming Page
    'adminGaming.title': 'Gaming Sayfası',
    'adminGaming.subtitle': 'Gaming sayfası hero ve kategori kartlarını düzenleyin',
    'adminGaming.heroDesc': 'Gaming sayfası ana başlık',
    'adminGaming.heroHighlight': 'Vurgulanan Metin',
    'adminGaming.categories': 'Kategori Kartları',
    'adminGaming.categoriesDesc': 'Gaming sayfasında gösterilen kategori kartları',
    'adminGaming.addCategory': 'Kategori Ekle',
    'adminGaming.category': 'Kategori',
    'adminGaming.categoryKey': 'Kategori Anahtarı (ürün kategorisiyle eşleşmeli)',
    'adminGaming.categoryLabel': 'Görüntülenecek Etiket',
    'adminGaming.categoryImage': 'Kart Görseli URL',

    // Admin Office Page
    'adminOffice.title': 'Ev & Ofis Sayfası',
    'adminOffice.subtitle': 'Ev & Ofis sayfası hero ve kategori kartlarını düzenleyin',
    'adminOffice.heroDesc': 'Ofis sayfası ana başlık',
    'adminOffice.heroHighlight': 'Vurgulanan Metin',
    'adminOffice.categories': 'Kategori Kartları',
    'adminOffice.categoriesDesc': 'Ofis sayfasında gösterilen kategori kartları',

    // Admin Support Page
    'adminSupport.title': 'Destek Sayfası',
    'adminSupport.subtitle': 'Destek sayfası hero ve kategori bölümlerini düzenleyin',
    'adminSupport.heroDesc': 'Destek sayfası ana başlık',
    'adminSupport.categories': 'Destek Kategorileri',
    'adminSupport.categoriesDesc': 'Destek sayfasında kılavuzlarla gösterilen ürün kategorileri',
    'adminSupport.addCategory': 'Kategori Ekle',
    'adminSupport.category': 'Kategori',
    'adminSupport.categoryKey': 'Kategori Anahtarı (ürün kategorisiyle eşleşmeli)',
    'adminSupport.categoryLabel': 'Görüntülenecek Etiket',
    'adminSupport.categoryProductType': 'Ürün Tipi (gaming/office)',

    // Admin Header & Footer
    'adminHF.title': 'Ust & Alt Bilgi',
    'adminHF.subtitle': 'Logo, navigasyon etiketleri, dil bayraklari ve alt bilgi icerigini duzenleyin',
    'adminHF.logos': 'Site Logolari',
    'adminHF.logosDesc': 'Sitede kullanilan VIYERO logolarini yonetin',
    'adminHF.headerLogo': 'Ust Bilgi Logosu (Ana)',
    'adminHF.footerLogo': 'Alt Bilgi Logosu (Beyaz)',
    'adminHF.gamingLogo': 'Gaming Alt-Marka Logosu',
    'adminHF.navLabels': 'Navigasyon Menu Etiketleri',
    'adminHF.navLabelsDesc': 'Ust navigasyon menusunde gosterilen metinleri duzenleyin',
    'adminHF.langFlags': 'Dil Bayraklari',
    'adminHF.langFlagsDesc': 'Dil degistirici icin ozel bayrak gorselleri',
    'adminHF.enFlag': 'Ingilizce Bayrak Gorseli',
    'adminHF.trFlag': 'Turkce Bayrak Gorseli',
    'adminHF.footerContent': 'Alt Bilgi Icerigi',
    'adminHF.footerContentDesc': 'Alt bilgi metni, bolum basliklari ve iletisim bilgilerini duzenleyin',
    'adminHF.footerDescription': 'Alt Bilgi Aciklamasi',
    'adminHF.productsTitle': 'Urunler Bolum Basligi',
    'adminHF.companyTitle': 'Sirket Bolum Basligi',
    'adminHF.gamingLink': 'Gaming Baglanti Metni',
    'adminHF.officeLink': 'Ofis Baglanti Metni',
    'adminHF.aboutLink': 'Hakkimizda Baglanti Metni',
    'adminHF.contactLink': 'Iletisim Baglanti Metni',
    'adminHF.email': 'Iletisim E-postasi',
    'adminHF.address': 'Adres',
  }
};
